import { combineReducers } from '@gasbuddy/react';
import auth from './auth';
import payReducers from './payments';
import sysReducers from './system';
import poiReducers from './poi';
import * as identityReducers from './identity';
import { Action } from './actions';

export { Action } from './actions';

const baseLen = Action.Api.Base.length;
const PENDING = '_PENDING';
const FULFILLED = '_FULFILLED';

function api(apiState = {}, action) {
  if (action && action.type.startsWith(Action.Api.Base)) {
    if (action.type.endsWith(PENDING)) {
      const apiName = action.type.substring(baseLen, action.type.length - PENDING.length);
      return {
        ...apiState,
        [apiName]: { loading: true },
      };
    } if (action.type.endsWith(FULFILLED)) {
      const apiName = action.type.substring(baseLen, action.type.length - FULFILLED.length);
      return {
        ...apiState,
        [apiName]: {
          loading: false,
          status: action.payload.status,
          body: action.payload.body,
        },
      };
    }
  }

  switch (action.type) {
    case Action.Api.Clear:
      return {
        ...apiState,
        [action.payload]: null,
      };
    case Action.Api.Pending:
      return {
        ...apiState,
        loading: true,
      };
    case Action.Api.Completed:
      return {
        ...apiState,
        loading: false,
        status: action.payload.status,
        body: action.payload.body,
      };
    default:
      break;
  }
  return apiState;
}

export default combineReducers({
  auth,
  api,
  ...payReducers,
  ...sysReducers,
  ...identityReducers,
  ...poiReducers,
});
